/* eslint-disable max-lines */
import React, { useContext, useState, useCallback } from "react";
import AppContext from "../../AppContext";
import { getCurrentOrder } from "../../selectors";
import { GreyTextareaWithLabel } from "../../Components";
import { getTranslateByScope } from "../../i18n";
import { debounce } from "../../utils/debounce";

const translate = getTranslateByScope("app.currentOrder");

// eslint-disable-next-line prefer-const
let timer = null;

export const OrderProductDescription = ({ notes, id }) => {
  const [editState, setEditState] = useState(notes);
  const context = useContext(AppContext);
  const order = getCurrentOrder(context).doc
    ? getCurrentOrder(context).doc
    : null;

  const onChange = useCallback(
    (n) => {
      context.actions.onAddOrUpdateOrderProduct({
        order,
        product: {
          id,
          notes: n,
        },
        onSuccess: () => {},
      });
    },
    [context.actions, id, order],
  );

  return (
    <GreyTextareaWithLabel
      onChange={(value) => {
        setEditState(value);
      }}
      onBlur={(value) => {
        debounce({ onChange, value, timer });
      }}
      label={translate("notes")}
    >
      {editState}
    </GreyTextareaWithLabel>
  );
};

export default OrderProductDescription;
